module.exports = __webpack_public_path__ + "static/media/bg-classes.799ad7b4.svg";